import Titulo from '../containers/Titulo'

const initialState = {
  versionLaridae: null,
  title: Titulo,
  showFooter: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'ULTIMA_VERSION':
      return {
        ...state,
        versionLaridae: action.data.ultimaVersion
      }
    case 'SET_TITULO':
      return {
        ...state,
        title: action.titulo
      }
    case 'SET_SHOW_FOOTER':
      return {
        ...state,
        showFooter: action.show
      }
    default:
      return state
  }
}
